import Consultant from "../models/Consultant";
import NewSessionId from "../common/SessionGenerator";
import {plainToInstance} from 'class-transformer'

const GetTranslations = (locale: string): Promise<{ [key: string]: string }> => {
    return fetch(`/locale/${locale}`)
        .then(response => response
            .json()
        );
}

export default GetTranslations;
